module.exports = __webpack_public_path__ + "img/kfe.e62af91a.png";